import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { setCurrentQueue } from 'modules/queues/actions'
import { setCurrentSite } from 'modules/sites/actions'
import { getCurrentSiteId } from 'modules/sites/selectors'
import { getCurrentQueue } from 'modules/queues/selectors'


/**
 * This is void component that always returns null.
 * Its getting use of React component's lifecycle hook to sync redux store with router's params.
 *
 */
class RouteStateSetter extends React.Component {
  static propTypes = {
    currentQueue: PropTypes.string,
    currentSite: PropTypes.string,
    match: PropTypes.shape({
      params: PropTypes.shape({
        siteId: PropTypes.string,
        queueId: PropTypes.string,
      }),
    }).isRequired,
    setCurrentQueue: PropTypes.func.isRequired,
    setCurrentSite: PropTypes.func.isRequired,
  }

  /**
   *
   * @param {object} props
   * @return {{nextSiteId: (string|null), nextQueueId: (string|null)}}
   */
  static getSiteAndQueueId(props) {
    const { siteId, queueId } = props.match.params;

    return {
      siteId: siteId || null,
      queueId: queueId || null,
    }
  }

  componentDidMount() {
    this.setRouteState(this.props, true)
  }

  shouldComponentUpdate(nextProps) {
    const { siteId, queueId } = RouteStateSetter.getSiteAndQueueId(this.props);
    const { siteId: nextSiteId, queueId: nextQueueId } = RouteStateSetter.getSiteAndQueueId(nextProps);

    return siteId !== nextSiteId || queueId !== nextQueueId;
  }

  componentWillUpdate(nextProps) {
    this.setRouteState(nextProps)
  }

  setRouteState(props, initial) {
    const { setCurrentQueue, setCurrentSite } = props;
    const { siteId, queueId } = RouteStateSetter.getSiteAndQueueId(this.props);
    const { siteId: nextSiteId, queueId: nextQueueId } = RouteStateSetter.getSiteAndQueueId(props);

    if (initial || (nextSiteId !== siteId)) {
      setCurrentSite(nextSiteId)
    }

    if (initial || (nextSiteId && queueId !== nextQueueId)) {
      setCurrentQueue(nextSiteId, nextQueueId)
    }
  }

  render() {
    return null;
  }
}


export default connect(
  createStructuredSelector({
    currentSite: getCurrentSiteId,
    currentQueue: getCurrentQueue,
  }),
  {
    setCurrentQueue,
    setCurrentSite,
  },
)(RouteStateSetter)



// WEBPACK FOOTER //
// ./src/components/app/route-state-setter.js